var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.nodata)?_c('div',{staticClass:"nodataBox"},[_vm._v("暂无数据")]):_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":'echart3'+_vm.index}})}
var staticRenderFns = []

export { render, staticRenderFns }